import { gql } from '@apollo/client';

export const GQL_LIKE_PROCESS = gql`
  mutation LikeProcess($_id: ID, $modelName: String, $owner_id: ID) {
    likeProcess(_id: $_id, modelName: $modelName, owner_id: $owner_id)
  }
`;
